import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-100 border border-background-200/50 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-3">
              <i className="ri-smartphone-line mr-1"></i>移动端
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {appContent.title}
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5">
              {appContent.subtitle}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {appContent.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="w-5 h-5 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-xs"></i>
                  </span>
                  {feat}
                </div>
              ))}
            </div>
            <a
              href="#app"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-download-line"></i>
              下载移动客户端
            </a>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-48 md:w-56">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20dark%20mobile%20phone%20mockup%20showing%20cinema%20streaming%20app%20interface%20with%20movie%20posters%20warm%20golden%20accents%20on%20dark%20screen%20luxurious%20atmosphere&width=500&height=800&seq=app-mockup-cinema&orientation=portrait"
                alt="琪琪影院移动客户端"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}